"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = require("@angular/core");
var cool_local_storage_1 = require("./src/cool-local-storage");
var cool_local_storage_2 = require("./src/cool-local-storage");
exports.CoolLocalStorage = cool_local_storage_2.CoolLocalStorage;
var cool_session_storage_1 = require("./src/cool-session-storage");
var cool_session_storage_2 = require("./src/cool-session-storage");
exports.CoolSessionStorage = cool_session_storage_2.CoolSessionStorage;
var CoolStorageModule = CoolStorageModule_1 = function () {
  function CoolStorageModule() {}
  /** @deprecated */
  CoolStorageModule.forRoot = function () {
    return {
      ngModule: CoolStorageModule_1,
      providers: []
    };
  };
  return CoolStorageModule;
}();
CoolStorageModule = CoolStorageModule_1 = __decorate([core_1.NgModule({
  providers: [cool_local_storage_1.CoolLocalStorage, cool_session_storage_1.CoolSessionStorage]
})], CoolStorageModule);
exports.CoolStorageModule = CoolStorageModule;
var CoolStorageModule_1;